import React from 'react'
import { BUSINESS, MERCHANT, PERSONAL } from '../../constants'
import { useMessage } from '../../hooks/useMessage'
import { componentNames } from '../../utils/analytics/fpti-constants'
import { ARTICLE_CONTENT_TABS_DATA } from '../../utils/prop-type-shape'
import ArticleContent from '../article-content'
import TabSwitcher from '../tab-switcher'

import './article-content-tabs.less'

export const ArticleContentTabs = ({
  articleContent,
  articleId,
  accountType,
}) => {
  const { personalContent, businessContent } = articleContent
  const { getMessage } = useMessage()

  const renderArticleContent = ({ content, exp }) => {
    const { articleTitle, ecmComponentIds, ecmDocId } = articleContent
    return (
      <ArticleContent
        articleContent={{
          articleContent: content,
          articleTitle,
          ecmComponentIds,
          ecmDocId,
        }}
        articleId={articleId}
        exp={exp}
      />
    )
  }

  const renderTabSwitcher = () => {
    const tabs = []
    if (personalContent) {
      tabs.push({
        id: 'consumerArticleContent',
        label: getMessage('app.helpcenter.experience.personal'),
        tabProps: {
          content: personalContent,
          exp: PERSONAL,
          componentName: componentNames.ARTICLE_CONTENT,
        },
      })
    }
    if (businessContent) {
      tabs.push({
        id: 'merchantArticleContent',
        label: getMessage('app.helpcenter.experience.business'),
        tabProps: {
          content: businessContent,
          exp: BUSINESS,
          componentName: componentNames.ARTICLE_CONTENT,
        },
      })
    }
    if (tabs.length === 2 && accountType === MERCHANT) {
      tabs.reverse()
    }
    if (tabs.length) {
      return (
        <TabSwitcher
          name="articleContentTabs"
          renderTabContent={renderArticleContent}
          tabsInfo={tabs}
          articleId={articleId}
        />
      )
    }
    return null
  }

  return renderTabSwitcher()
}

ArticleContentTabs.propTypes = ARTICLE_CONTENT_TABS_DATA
